export default __webpack_public_path__ + "static/media/checkin-hero-left.6d06a944.png";